export default "__VITE_PUBLIC_ASSET__74a04626__"